angular
 .module('vppApp')
 	.factory('AuthRequestInformation', function() {

		var AuthRequestInformation = {
		   "programID" : "",
		   "programCode" : "",
		   "relationship" : "",
		   "emailAddress" : "",
		   "secondaryPassword" : ""
		};

		return AuthRequestInformation;

 });